import { styled } from '@mui/material/styles';
export const DateTimeViewWrapper = styled('div')({
  display: 'flex',
  margin: '0 auto'
});